import React, {useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import {themeButtons} from "../../css/themeButtons";
import {Button, useMediaQuery} from "@material-ui/core";
import ContractTableRow from "../common/ContractTableRow/ContractTableRow";
import {CustomTooltip} from "../CalendarPercent/styles";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {useQuery} from "../common/CustomHook/useQuery";
import Box from "@material-ui/core/Box";


const ContractSample = (props) => {
    const {baseUrl} = props

    const [type, setType] = useState()

    const mobileAgent = useMediaQuery('(max-width: 974px)');

    const query = useQuery();


    useEffect(() => {
        setType(query.get("type"))
    }, [])

    const buttons = themeButtons()

    if (!type || (type !== "percent" && type !== "subscriber")) {
        return (
            <div className="main">
                <div className="container-fluid">
                    <Box className="alert alert-warning">
                        Ошибка! Возможно ссылка не актуальна.
                        <Button component={NavLink} className={`btn ${buttons.btnGreen} ms-2`}
                                to={"/lk/contracts"}>
                            Вернуться
                        </Button>
                    </Box>
                </div>
            </div>
        )
    }

    return (
        <div className="main">
            <div className="container-fluid">

                <iframe
                    src={`${baseUrl}/${type === "percent" ? "com_contract_template.pdf" : "abon_contract_template.pdf"}`}
                    style={{height: mobileAgent ? "50vh" : "75vh", width: "1px", minWidth: "100%"}} frameBorder="0"
                    type="application/pdf"/>

            </div>
        </div>

    )
}


export default ContractSample;